import { render, staticRenderFns } from "./BarangSelector.vue?vue&type=template&id=f1366856&"
import script from "./BarangSelector.vue?vue&type=script&lang=js&"
export * from "./BarangSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports